import React, { ReactNode } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

const WorkExperienceContext = React.createContext<{
    value: null;
    set: (v: any) => void;
} | undefined>(undefined);

export const WorkExperienceProvider = ({ children }: { children: ReactNode }) => {
    const [v, setV] = React.useState(null);

    return (
        <WorkExperienceContext.Provider
            value={{
                value: v,
                set: () => {},
            }}
        >
            {children}
        </WorkExperienceContext.Provider>
    );
};

export const useWorkExperience = () => {
    const ctx = React.useContext(WorkExperienceContext);
    if (!ctx) {
        throw new Error('useWorkExperience must be used inside WorkExperienceProvider');
    }
    return ctx;
};
